import React from "react";

const StyledMdText = ({ children, font }) => {
  return (
    <p className={`text-md font-star-jedi lowercase ${font}`}>{children}</p>
  );
};

export default StyledMdText;
